export default "__VITE_ASSET__CKkGkan___"